import {
  Box,
  Center,
  useColorModeValue,
  Heading,
  Text,
  Stack,
  Image,
} from "@chakra-ui/react";


const IMAGE =
  "https://images.unsplash.com/photo-1518051870910-a46e30d9db16?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=80";

export default function MovieListing({data}) {
  const {image,name,price} = data
  console.log({image,name,price})
  return (
    <Center py={12}>
      <Box
        role={"group"}
        p={6}
        width={"330px"}
        // w={"full"}
        //bgGradient='linear(to-r, purple.900, purple.300)'
        backgroundColor={"purple.800"}
        boxShadow={"2xl"}
        rounded={"lg"}
        pos={"relative"}
      >
        <Box
          rounded={"lg"}
          mt={-12}
          pos={"relative"}
          height={"230px"}
          _after={{
            transition: "all .3s ease",
            content: '""',
            w: "full",
            h: "full",
            pos: "absolute",
            top: 5,
            left: 0,
            backgroundImage: `url(${image || IMAGE})`,
            filter: "blur(15px)",
            zIndex: -1,
          }}
          _groupHover={{
            _after: {
              filter: "blur(20px)",
            },
          }}
        >
          <Image
            rounded={"lg"}
            height={230}
            width={282}
            objectFit={"fit"}
            src={image}
            alt="#"
          />
        </Box>
        <Stack pt={10} align={"center"}>
          <Heading fontSize={"2xl"} fontFamily={"body"} fontWeight={500}>
          {name || "Movie Name"}
          </Heading>
          <Stack direction={"row"} align={"center"}>
            <Text fontWeight={800} fontSize={"xl"} color={"#d5d5d5"}>
              {price||"Price"}
            </Text>
          </Stack>
        </Stack>
      </Box>
    </Center>
  );
}
